import React, { useRef } from "react";
import styles from "../../../src/views/OtpVerify/Styles.module.css";
// import DashboardSnackbar from "../../../components/Snackbar.component";
import classNames from "classnames";
import logoImage from "../../../src/assets/CRMAssets/psconnect_sidebar_updated.png";
import { IconButton, ButtonBase, Typography, Input, Button, CircularProgress } from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import CustomTextField from "../../../src/components/FormFields/TextField/TextField.component";
import { useTheme } from "@mui/styles";
import { useSelector } from "react-redux";
import useOtpVerifyHook from "../../../src/views/OtpVerify/OtpVerify.hook";
import { ArrowPrimaryButton } from "../../components/Buttons/PrimaryButton";
import PhoneNo from "../../views/LoginDietitian/Component/Phone";
import historyUtils from "../../../src/libs/history.utils";
import SnackbarUtils from "../../libs/SnackbarUtils";
import DashboardSnackbar from "../../../src/components/Snackbar.component";


function OtpVerifyView() {
    const theme = useTheme();
    const { domainTheme } = useSelector((state) => state.app_setting || {});
    const cachedTheme = !domainTheme ? (() => {
        try {
            const currentDomain = (typeof window !== 'undefined' && window.location.hostname) ? window.location.hostname : '';
            const domainKey = currentDomain ? `client_theme_${currentDomain}` : null;
            return JSON.parse((domainKey && localStorage.getItem(domainKey)) || localStorage.getItem('domain_theme_data') || localStorage.getItem('domainTheme') || '{}');
        } catch (e) {
            return {};
        }
    })() : null;
    const activeTheme = domainTheme || cachedTheme || {};

    const logoUrl = activeTheme.display_logo || activeTheme.logo || activeTheme.logo_url || logoImage;
    const bgUrl = activeTheme.background_image || activeTheme.login_background || activeTheme.bg_image;

    const {
        handleSubmit,
        otp,
        inputRefs,
        handleKeyPress,
        isValid,
        // handleResendOtp,
        disableResend,
        timerCounter,
        handleVerifyOtp,
        errorOtp,
        snackbar,
        setSnackbar,
       submitting,
        handleChnageContact,
        contact
    } = useOtpVerifyHook();

    return (
        <div className={"login"}>
            <div
                className={styles.overlay}
                style={bgUrl ? { display: "none" } : {}}
            />
            <div
                className={styles.mainLoginView}
                style={bgUrl ? {
                    backgroundImage: `url(${bgUrl})`,
                    backgroundSize: "cover",
                    backgroundPosition: "center",
                    backgroundRepeat: "no-repeat"
                } : {}}
            />
            <div className={styles.container}>
                <div className={styles.loginFlex2}>
                    <div className={styles.logoImageData}>
                        <img
                            src={logoUrl}
                            alt="logo"
                            style={{ width: "250px", height: "80px", objectFit: "contain" }}
                            onError={(e) => { e.target.onerror = null; e.target.src = logoImage; }}
                        />
                    </div>
                    <div className={styles.signContainer}>
                        <div className={styles.loginHeaderText}>
                            <Typography variant="h3">OTP Verification</Typography>

                            <Typography
                                variant={"body1"}
                                sx={{ color: theme?.palette?.text?.secondary }}
                            >
                                You would have got a 8 digit code on <span>{contact ? contact : "+91 9872346788"}</span>
                                <Typography
                                    component="span"
                                    sx={{
                                        color: theme.palette.primary.main,
                                        cursor: "pointer",
                                        ml: 1,
                                        textDecoration: "underline",
                                    }}
                                    onClick={() => handleChnageContact("/login")}
                                >
                                    Change Number
                                </Typography>
                            </Typography>
                        </div>

                        <div className={styles.formContainer}>
                            <div className={styles.formFlexGrouup}>
                                <div className={"formGroup"}>
                                    {Array.from({ length: 8 }).map((_, index) => (
                                        <Input
                                            key={index}
                                            className={styles.inputFields}
                                            type="text"
                                            name={`${index}`}
                                            inputRef={(el) => (inputRefs.current[index] = el)}
                                            value={otp[index] || ""}
                                            inputProps={{ maxLength: 1 }}
                                            onChange={(e) => handleKeyPress(e, index)}
                                            onKeyDown={(e) => handleKeyPress(e, index)}
                                        />

                                    ))}

                                </div>

                            </div>
                        </div>

                        <div className={styles.loginAction}>
                            <Button
                                variant={"h6"}
                                onClick={() => handleSubmit()}
                            >
                                {submitting ? (
                                    <CircularProgress size={24} color={"primary"} />
                                ) : (
                                    "VERIFY"
                                )}
                            </Button>
                        </div>

                    </div>
                </div>

            </div>
            <DashboardSnackbar />
        </div>
    );
}

export default OtpVerifyView;
